import _ from "lodash";
import { I18N } from "oc-I18N";
import * as Commons from "oc-commons/Commons";
import * as Doms from "oc-ui/Doms";
import React from "react";
import { Segment } from "../arrangement/Segment";
import {
  getRichProfilkategorien,
  öffnungswinkelItem,
  öffnungswinkelItemOf,
} from "../arrangement/elementFunctions";
import { AbstractPart3d } from "../arrangement3d/AbstractPart3d";
import * as Utils from "../commons/Utils";
import { nextItem } from "../commons/Utils";
import { Tab, Tabs } from "../components/Tabs";
import { FertigButton } from "../components/zauneditor/FertigButton";
import { FertigDialog } from "../components/zauneditor/FertigDialog";
import { DekorOptionen } from "../components/zauneditor/DekorOptionen";
import { LichtOptionen } from "../components/zauneditor/LichtOptionen";
import { Price } from "../components/zauneditor/Price";
import { SceneButtons } from "../components/zauneditor/SceneButtons";
import { TorOptionen } from "../components/zauneditor/TorOptionen";
import { TorMontageplattenOptionen } from "../components/zauneditor/TorMontageplattenOptionen";
import { ZaunCircleMenu } from "../components/zauneditor/ZaunCircleMenu";
import { ZaunCircleMenuItemAOrBView } from "../components/zauneditor/ZaunCircleMenuItemAOrBView";
import { ZaunCircleMenuItemAnker } from "../components/zauneditor/ZaunCircleMenuItemAnker";
import { ZaunCircleMenuItemAnkerAusrichtung } from "../components/zauneditor/ZaunCircleMenuItemAnkerAusrichtung";
import {
  ZaunCircleMenuItemAufbautenPos,
  ZaunCircleMenuItemAufbautenSize,
} from "../components/zauneditor/ZaunCircleMenuItemAufbautenSizePos";
import { ZaunCircleMenuItemAuffüllen } from "../components/zauneditor/ZaunCircleMenuItemAuffüllen";
import { ZaunCircleMenuItemAusgleichGefälle } from "../components/zauneditor/ZaunCircleMenuItemAusgleichGefälle";
import { ZaunCircleMenuItemElementSize } from "../components/zauneditor/ZaunCircleMenuItemElementSize";
import { ZaunCircleMenuItemEmptyAsMauer } from "../components/zauneditor/ZaunCircleMenuItemEmptyAsMauer";
import { ZaunCircleMenuItemFillWithElements } from "../components/zauneditor/ZaunCircleMenuItemFillWithElements";
import { ZaunCircleMenuItemFlipElement } from "../components/zauneditor/ZaunCircleMenuItemFlipElement";
import { ZaunCircleMenuItemFlipAnschlag } from "../components/zauneditor/ZaunCircleMenuItemFlipAnschlag";
import { ZaunCircleMenuItemIcons } from "../components/zauneditor/ZaunCircleMenuItemIcons";
import { ZaunCircleMenuItemInfo } from "../components/zauneditor/ZaunCircleMenuItemInfo";
import { ZaunCircleMenuItemProfil } from "../components/zauneditor/ZaunCircleMenuItemProfil";
import { ZaunElementList } from "../components/zauneditor/ZaunElementList";
import { MouseTutorialStepEngine } from "../components/tutorial/MouseTutorialStepEngine";
import { ChatBot } from "../components/chatbot/ChatBot";
import { DialogContainer } from "oc-ui/dialogs/Dialogs";
import { FüllungsMenu } from "../components/zauneditor/FüllungsMenu";
import { JoyrideTour } from "../components/zauneditor/JoyrideTour";
import { AbschlussLeistenOptionen } from "../components/zauneditor/AbschlussLeistenOptionen";
import { PfostenOptionen } from "../components/zauneditor/PfostenOptionen";
import { AufsatzLeistenOptionen } from "../components/zauneditor/AufsatzLeistenOptionen";
import { ZaunCircleMenuItemVerteilungsstrategie } from "../components/zauneditor/ZaunCircleMenuItemVerteilungsstrategie";
import { ZElement } from "../arrangement/ZElement";
import * as Dialogs from "oc-ui/dialogs/Dialogs";

const onSelectElement = () => {
  //TODO: Hier das switchen der editor-optionen hin?
};

interface Vector3Like {
  x: number;
  y: number;
  z: number;
}

type SelectedObjectType = {
  isPfostenAnEcke?: boolean;
  isEmpty?: boolean;
  isAufbau?: boolean;
  isPfosten?: boolean;
  segment: Segment;
  isTor?: boolean;
  torÖffnungswinkel?: number;
};

export class Zauneditor extends React.Component {
  pageNeeds = {
    scene: true,
    background: false,
    pageTypeForCssAnimation: 4,
  };

  pageActive = false;
  zaunCircleMenu = React.createRef<ZaunCircleMenu>();
  mouseTutorialRef = React.createRef<MouseTutorialStepEngine>();
  cameraConfigSaved: {
    object: Vector3Like;
    target: Vector3Like;
    up: Vector3Like;
  };
  enableZaunSelection = true;
  tutorialMode = false;
  fadedIn = false;

  mobileAnimationSelector = ".scene-buttons, .tabs";

  async init({
    pageEnteredInSequence,
    pageBeforeNeeds,
  }: {
    pageEnteredInSequence: boolean;
    pageBeforeNeeds: { zaun?: boolean };
  }) {
    this.pageNeeds.background = pageBeforeNeeds.zaun;
    APP.controls.maxDistance = 50;
    APP.arrangement.visible = false;
    if (APP.arrangement.jaco3d) APP.arrangement.jaco3d.visible = false;
    APP.arrangement.initFüllungAuswahlwertHistory();
    // für smoothe Anims etwas warten
    await this.zaunansichtAnimation(pageEnteredInSequence);
    await this.showMouseTutorialOnlyFirstTime(() => {
      APP.resetShadowPlane();
      this.cameraConfigSaved = STAGE.getCurrentCameraConfig();
    });
    APP.controls.enabled = true;
    APP.arrangement.zauneditorReady = true;
    APP.arrangement.zauneditorVisited = true;
    APP.dirty();
    APP.undoHandler.enabled = true;

    this.checkMissingKeys();
    APP.on("loadedInitialConfiguration", this.checkMissingKeys);

    setTimeout(() => APP.arrangement.maybeHighlightBreadcrumb("Grundriss"), 3500);
  }

  checkMissingKeys = () => {
    if (
      !Commons.isEmpty(APP.configuration.Code) &&
      APP.richMetadata.missingAuswahlwertKeys.size > 0
    ) {
      Dialogs.showWarning(
        I18N("Einige Artikel sind nicht mehr verfügbar. Die Zaunanlage wurde angepasst.")
      );
      APP.richMetadata.clearMissingAuswahlwertKeys();
    }
  };

  async exit() {
    APP.arrangement.zauneditorReady = false;
    APP.undoHandler.enabled = false;
    APP.arrangement.showStückliste = false;
  }

  componentDidMount() {
    APP.on("selectZaunelementOrPfosten", onSelectElement);
    window.addEventListener("keydown", handleKeyboardEvent);
    window.addEventListener("resize", this.onWindowResize);
  }

  componentWillUnmount() {
    APP.off("selectZaunelementOrPfosten", onSelectElement);
    APP.off("loadedInitialConfiguration", this.checkMissingKeys);
    window.removeEventListener("keydown", handleKeyboardEvent);
    window.removeEventListener("resize", this.onWindowResize);
    APP.arrangement.storeBackupForZauneditorComparison();
  }

  cameraReset() {
    APP.stopAllAnimations();
    APP.arrangement.setSelectedObjects(null, true);
    APP.arrangement.isMultiselecting = false;
    APP.zoomCameraToPart(null);
  }

  async setSelectedObjects(part: SelectedObjectType) {
    const event: PointerEvent = APP.interactionHandler.event;

    if (!(APP.controls.enabled && this.enableZaunSelection)) {
      return;
    }
    const agt = APP.arrangement;

    const selected = agt.selectedObjects;
    const result = [];
    let doUpdate = true;

    if (part != null) {
      const combineable =
        selected.length == 0 ||
        selected.every(
          (e) =>
            e.isPfosten == part.isPfosten &&
            e.isAufbau == part.isAufbau &&
            e.isEmpty == part.isEmpty
        );
      const previousSelected = selected.includes(part);
      const multiClickOnSame = selected.length == 1 && previousSelected;
      const isPartOfSegment = !part.isPfostenAnEcke && !part.isAufbau;
      const containsEckpfosten = selected.some((part) => part.isPfostenAnEcke);
      const removePart = () => result.push(...selected.filter((p) => p != part));
      const addPart = () => result.push(...selected, part);
      const getLookUp = (segment: Segment) =>
        part.isPfosten
          ? segment.getPfosten()
          : part.isEmpty
            ? segment.getEmpties()
            : segment.getParts().filter((e) => e.isElement);
      const addSequence = (replace = false) => {
        const segment = part.segment;
        //@ts-ignore
        const last = selected.findLast((e) => e.segment == segment);
        if (last == null) {
          addPart();
        } else {
          const parts = getLookUp(segment);
          const fromIndex = parts.indexOf(last);
          const toIndex = parts.indexOf(part);
          let currentIndex = fromIndex;
          const added: SelectedObjectType[] = [];
          while (currentIndex != toIndex) {
            added.unshift(parts[currentIndex]);
            currentIndex += fromIndex < toIndex ? 1 : -1;
          }
          added.unshift(part);
          result.push(...(replace ? [] : selected.filter((e) => !added.includes(e))), ...added);
        }
      };
      const removeSequence = () => {
        const segment = part.segment;
        const start = selected.indexOf(part);
        const toBeUnselected: SelectedObjectType[] = [];
        for (let i = start + 1; i < selected.length && selected[i].segment == segment; i++) {
          toBeUnselected.push(selected[i]);
        }
        result.push(...selected.filter((e) => !toBeUnselected.includes(e)));
      };

      if (
        (event?.ctrlKey || event?.metaKey) &&
        event?.shiftKey &&
        isPartOfSegment &&
        !containsEckpfosten
      ) {
        if (combineable && !previousSelected) addSequence();
        else if (previousSelected) removePart();
        else doUpdate = false;
      } //
      else if (event?.ctrlKey || event?.metaKey || APP.arrangement.isMultiselecting) {
        if (combineable && !previousSelected) addPart();
        else if (previousSelected) removePart();
        else doUpdate = false;
      } //
      else if (event?.shiftKey && isPartOfSegment && !containsEckpfosten) {
        if (combineable && !previousSelected) addSequence(true);
        else if (previousSelected) removeSequence();
        else doUpdate = false;
      } //
      else {
        if (!previousSelected || selected.length > 1) {
          result.push(part);
        }
        if (part.isTor) {
          // Bei neuer Einzel-Selektion eines Tors immer den Tore-Tab anzeigen.
          if (!multiClickOnSame && result.length === 1) {
            APP.arrangement.activeTabKey = "Tor";
          } else if (!this.isTabStillValidForSelection(APP.arrangement.activeTabKey, result)) {
            APP.arrangement.activeTabKey = "Tor";
          }
          if (multiClickOnSame) {
            const element = part as ZElement;
            if (element.isSchiebetor) {
              element.schiebetorOffen = !element.schiebetorOffen;
            } else {
              element.torÖffnungswinkel = nextItem(
                öffnungswinkelItem(part).map((w) => w.angle),
                öffnungswinkelItemOf(part).angle
              );
            }
            APP.dirty();
          }
        } else if (part.isPfosten) {
          if (!this.isTabStillValidForSelection(APP.arrangement.activeTabKey, result)) {
            APP.arrangement.activeTabKey = "Pfosten";
          }
          APP.updateUI();
        } else {
          if (!this.isTabStillValidForSelection(APP.arrangement.activeTabKey, result)) {
            APP.arrangement.activeTabKey = "Elemente";
          }
          APP.updateUI();
        }
        doUpdate = !multiClickOnSame;
      }
    }

    if (doUpdate) {
      await APP.arrangement.setSelectedObjects(result);
    }
  }

  onTapObject3D(dragObject3d: AbstractPart3d) {
    if ((dragObject3d as any).isIndividualisierungLockIcon) {
      return;
    }
    this.setSelectedObjects(dragObject3d.jaco as any);
  }

  onTapSceneOnly() {
    this.setSelectedObjects(null);
  }

  onShowDialog() {
    APP.arrangement.showStückliste = false;
    APP.updateUI();
  }

  onSelectionChangeStart() {
    if (APP.arrangement.selectedObjects.length > 0) {
      APP.arrangement.showStückliste = false;
      APP.updateUI();
    }
  }

  async onMaybeShowOptionenWithTabAnimation(tabKey: string, preventCondition?: boolean) {
    const agt = APP.arrangement;
    if (
      APP.arrangement.activeTabKey === tabKey ||
      agt.selectedObjects.length != 1 ||
      preventCondition
    ) {
      return;
    }
    APP.arrangement.activeTabKey = tabKey;
    APP.updateUI();
    await Commons.sleep(10);
    const tab = document.querySelector(`.editor-optionen`);
    tab.classList.add("highlight-overlay");
    await Commons.sleep(2100);
    tab.classList.remove("highlight-overlay");
  }

  async onMaybeShowPfostenOptionen() {
    this.onMaybeShowOptionenWithTabAnimation("Pfosten");
  }
  async onMaybeShowTorOptionen() {
    const agt = APP.arrangement;
    this.onMaybeShowOptionenWithTabAnimation("Tor", !agt.selectedObjects[0]?.isTor);
  }

  async onMaybeShowLichtleistenOptionen() {
    this.onMaybeShowOptionenWithTabAnimation("Lichtoptionen");
  }

  async zaunansichtAnimation(pageEnteredInSequence: boolean) {
    APP.resetShadowPlane();
    this.pageNeeds.background = true;
    APP.trigger("SceneBackgroundChange");
    APP.arrangement.visible = true;
    if (APP.arrangement.jaco3d) {
      APP.arrangement.jaco3d.visible = true;
    }
    await APP.zoomCameraToPart(null, true);
    APP.dirty();
  }

  onSceneEditorEditModeChange() {
    this.zaunCircleMenu?.current?.setScrollOrZooming(true);
    _.delay(() => {
      this.zaunCircleMenu?.current?.setScrollOrZooming(false);
    }, 1000);
  }

  onWindowResizeStart() {
    this.zaunCircleMenu?.current?.setScrollOrZooming(true);
  }

  onWindowResizeEnd() {
    this.zaunCircleMenu?.current?.setScrollOrZooming(false);
  }

  onControlsStart() {
    this.zaunCircleMenu?.current?.setScrollOrZooming(true);
  }

  onControlsEnd() {
    this.zaunCircleMenu?.current?.setScrollOrZooming(false);
  }

  onBeforeSaveConfiguration() {
    this.showPotentiellAblenkendeElemente(false);
    APP.updateUI();
  }

  onCloseFertigDialog() {
    this.showPotentiellAblenkendeElemente(true);
    APP.updateUI();
  }

  getTabVisibility(selected: any[]) {
    const agt = APP.arrangement;
    const firstElement = selected[0];
    const isTor = firstElement?.isTor;
    const onlyPfostenSelected = selected.length > 0 && selected.every((e) => e.isPfosten);
    const showPfostenTab =
      selected.length == 0 ||
      (selected.some((e) => e.isPfosten) && !selected.every((e) => e.isMontageplatten));
    const showAbschlussleistenTab =
      !onlyPfostenSelected &&
      agt.getSelectedOrAllElemente().some((e) => !_.isEmpty(e.meta.AbschlussleisteOben));
    const showAufsatzleistenTab =
      !onlyPfostenSelected &&
      agt.getSelectedOrAllElemente().some((e) => e.meta?.Aufsatzleiste?.length > 1);
    const showMontageplattenTab = isTor && !_.isEmpty(firstElement?.getWandmontagePlatten());
    const richProfilKategorien = getRichProfilkategorien();
    const richProfilKategorienNichtLicht = richProfilKategorien.filter(
      (k) => k.kategorieAuswahlwert?.Typinfo !== "Lichtleiste"
    );
    const showProfileTab = !onlyPfostenSelected && richProfilKategorienNichtLicht.length > 0;
    const showLichtoptionenTab = !onlyPfostenSelected && agt.trafoTrees.length > 0;
    return {
      onlyPfostenSelected,
      showPfostenTab,
      showAbschlussleistenTab,
      showAufsatzleistenTab,
      showMontageplattenTab,
      showProfileTab,
      showLichtoptionenTab,
      isTor,
    };
  }

  /**
   * Prüft ob der aktuelle Tab für die neue Selektion noch gültig wäre.
   * Falls ja, soll der Tab beibehalten werden statt auf den Default zu wechseln.
   */
  isTabStillValidForSelection(tabKey: string, newSelection: any[]): boolean {
    const {
      onlyPfostenSelected,
      showPfostenTab,
      showAbschlussleistenTab,
      showAufsatzleistenTab,
      showMontageplattenTab,
      showProfileTab,
      showLichtoptionenTab,
      isTor,
    } = this.getTabVisibility(newSelection);

    const tabAvailability: Record<string, boolean> = {
      Elemente: !onlyPfostenSelected,
      Tor: !!isTor,
      TorMontage: !!showMontageplattenTab,
      Pfosten: showPfostenTab,
      Abschlussleisten: showAbschlussleistenTab,
      Aufsatzleisten: showAufsatzleistenTab,
      Dekore: showProfileTab,
      Lichtoptionen: showLichtoptionenTab,
    };

    return tabAvailability[tabKey] ?? false;
  }

  onWindowResize = () => {
    if (window.innerWidth > 1000) {
      this.mobileAnimationSelector.split(",").forEach((selector) => {
        document.querySelector(selector).classList.remove("slide-out");
        document.querySelector(selector).classList.remove("slide-down");
      });
    }
  };

  showPotentiellAblenkendeElemente(show: boolean) {
    const setClassIf = (selector: string, clazz: string, show: boolean) => {
      Utils.querySelectorAll(selector).forEach((div) => Doms.setClassIf(div, clazz, show));
    };
    setClassIf(
      ".breadcrumbs,.rightMenu,.assistant,.bestell-buttons,.scene-buttons,.fuellung-menu",
      "hidden",
      !show
    );
    setClassIf(".editor-optionen,.pfosten-dekor-menu,.fuellung-menu", "display-none", !show);
  }

  async showMouseTutorialOnlyFirstTime(actionBeforeSelect: Function) {
    await this.mouseTutorialRef?.current?.showMouseTutorialOnlyFirstTime(actionBeforeSelect);
  }

  async showMouseTutorial() {
    await this.mouseTutorialRef?.current?.showMouseTutorial();
  }

  render() {
    APP.arrangement.updateAuswahlAccessoren();
    const firstElement = APP.arrangement.selectedObjects[0];
    const isTor = firstElement?.isTor;

    const agt = APP.arrangement;
    const selected = agt.selectedObjects;
    const {
      onlyPfostenSelected,
      showProfileTab,
      showLichtoptionenTab,
      showAbschlussleistenTab,
      showAufsatzleistenTab,
      showPfostenTab,
      showMontageplattenTab,
    } = this.getTabVisibility(selected);
    const elementOrLückeBearbeitung = selected.every((e) => e.isElement || e.isEmpty);
    const einzelnerPfostenSelected =
      selected.length == 1 && selected[0].isPfosten ? selected[0] : null;
    const pfostenTabHeader = einzelnerPfostenSelected?.isAnschlagprofil
      ? I18N("Anschlagprofil")
      : einzelnerPfostenSelected?.isUMProfil
        ? I18N("UMProfil")
        : einzelnerPfostenSelected?.isTorpfosten
          ? I18N("Torpfosten")
          : I18N("Pfosten");

    return (
      <>
        <DialogContainer />
        <div className="scene-overlay" />
        {!APP.testmode && APP.tutorialParam !== false && <JoyrideTour page="zauneditor" />}

        {elementOrLückeBearbeitung && <FüllungsMenu fadedIn={this.fadedIn} />}
        <Tabs
          className="editor-optionen tab-menu menu fade page-initial-hidden slide-in"
          aria-label={I18N("aria::Bearbeitungsoptionen")}
          activeTabKey={APP.arrangement.activeTabKey}
          setActiveTabKey={(key) => {
            APP.arrangement.activeTabKey = key;
            APP.updateUI();
          }}
          showToggleButton={true}
        >
          {!onlyPfostenSelected && (
            <Tab key="Elemente" tabKey="Elemente" header={I18N("Elemente")} className="">
              <ZaunElementList />
            </Tab>
          )}
          {isTor && (
            <Tab key="Tor" tabKey="Tor" header={I18N("Tore")} className="">
              <TorOptionen tor={APP.arrangement.selectedObjects[0]} />
            </Tab>
          )}
          {showMontageplattenTab && (
            <Tab key="TorMontage" tabKey="TorMontage" header={I18N("Montageplatte")} className="">
              <TorMontageplattenOptionen tor={APP.arrangement.selectedObjects[0]} />
            </Tab>
          )}
          {showPfostenTab && (
            <Tab key="Pfosten" tabKey="Pfosten" header={pfostenTabHeader}>
              <PfostenOptionen />
            </Tab>
          )}
          {showProfileTab && (
            <Tab key="Dekore" tabKey="Dekore" header={I18N("Dekore")}>
              <DekorOptionen />
            </Tab>
          )}
          {showLichtoptionenTab && (
            <Tab key="Lichtoptionen" tabKey="Lichtoptionen" header={I18N("Lichtoptionen")}>
              <LichtOptionen />
            </Tab>
          )}
          {showAbschlussleistenTab && (
            <Tab key="Abschlussleisten" tabKey="Abschlussleisten" header={I18N("Abschlussleiste")}>
              <AbschlussLeistenOptionen />
            </Tab>
          )}
          {showAufsatzleistenTab && (
            <Tab key="Aufsatzleisten" tabKey="Aufsatzleisten" header={I18N("Aufsatzleiste")}>
              <AufsatzLeistenOptionen />
            </Tab>
          )}
        </Tabs>

        <div
          className="grundriss grid-area-main no-pointer-events-tree"
          role="region"
          aria-label={I18N("aria::3D-Szene")}
        ></div>

        <SceneButtons zauneditor={this} />

        <div
          data-group-key="buttons-bottom-right"
          className={`bestell-buttons no-pointer-events fade page-initial-hidden ${
            APP.settings.tina.active && "chat-margin"
          }`}
          role="region"
          aria-label={I18N("aria::Preis und Abschluss")}
        >
          <Price />
          <FertigButton />
        </div>

        <ChatBot
          initialChatMessages={[I18N("TinaBegrüssungstext")]}
          avatarMessage={I18N("TinaZauneditor")}
          faqRootKey={"root_Zauneditor"}
        />

        {/* @ts-ignore //TODO: remove when ZaunCirleMenu is converted to tsx */}
        <ZaunCircleMenu ref={this.zaunCircleMenu}>
          <ZaunCircleMenuItemInfo />
          <ZaunCircleMenuItemElementSize />
          <ZaunCircleMenuItemVerteilungsstrategie />
          <ZaunCircleMenuItemAOrBView />
          {!selected.some((s) => s.fixedSize) && <ZaunCircleMenuItemAufbautenSize />}
          <ZaunCircleMenuItemAufbautenPos />
          <ZaunCircleMenuItemProfil />
          <ZaunCircleMenuItemAnker />
          <ZaunCircleMenuItemAnkerAusrichtung />
          <ZaunCircleMenuItemAusgleichGefälle />
          <ZaunCircleMenuItemFlipAnschlag />
          <ZaunCircleMenuItemFillWithElements />
          <ZaunCircleMenuItemEmptyAsMauer />
          <ZaunCircleMenuItemAuffüllen zaunCircleMenu={this.zaunCircleMenu} />
          <ZaunCircleMenuItemIcons zaunCircleMenu={this.zaunCircleMenu} />
          <ZaunCircleMenuItemFlipElement />
        </ZaunCircleMenu>

        {!APP.testmode && APP.tutorialParam !== false && (
          <MouseTutorialStepEngine ref={this.mouseTutorialRef} zauneditor={this} />
        )}

        <FertigDialog onClose={() => this.onCloseFertigDialog()} />
      </>
    );
  }
}

function handleKeyboardEvent(event: KeyboardEvent) {
  const CTRL_OR_CMD = event.ctrlKey || event.metaKey;
  const ALT = event.altKey;
  if (event.target !== document.body || window.getSelection().toString() != "") {
    return;
  }
  if (CTRL_OR_CMD && event.key == "z") {
    event.preventDefault();
    APP.undoHandler.undo();
  } else if (CTRL_OR_CMD && event.key == "y") {
    event.preventDefault();
    APP.undoHandler.redo();
  } else if (CTRL_OR_CMD && event.key == "c") {
    event.preventDefault();
    APP.arrangement.copySelected();
  } else if (CTRL_OR_CMD && event.key == "x") {
    event.preventDefault();
    APP.arrangement.cutSelected();
  } else if (CTRL_OR_CMD && event.key == "v") {
    event.preventDefault();
    APP.arrangement.pasteSelected();
  } else if (CTRL_OR_CMD && event.key == "a") {
    event.preventDefault();
    APP.arrangement.selectAllParts();
  } else if (ALT && event.key == "a") {
    event.preventDefault();
    APP.arrangement.selectAllPfosten();
  } else if (event.key == "Delete") {
    event.preventDefault();
    APP.arrangement.removeSelectedObjects();
  } else if (event.key == "Home") {
    //Pos1 Key
    event.preventDefault();
    APP.arrangement.setSelectedObjects(null);
  } else if (event.key == "ArrowLeft") {
    event.preventDefault();
    APP.arrangement.moveZaunelementSelection(-1);
  } else if (event.key == "ArrowRight") {
    event.preventDefault();
    APP.arrangement.moveZaunelementSelection(+1);
  } else if (event.key.toLowerCase() === "p") {
    STAGE.orbitcontrols.screenSpacePanning = !STAGE.orbitcontrols.screenSpacePanning;
    console.log("screenSpacePanning? " + STAGE.orbitcontrols.screenSpacePanning);
  } else if (event.key.toLowerCase() === "o") {
    const oldScreenSpacePanning = STAGE.orbitcontrols.screenSpacePanning;
    STAGE.orbitcontrols.screenSpacePanning = true;
    STAGE.orbitcontrols.panUp(0.1, STAGE.orbitcontrols.object.matrix);
    STAGE.orbitcontrols.screenSpacePanning = oldScreenSpacePanning;
  } else if (event.key.toLowerCase() === "l") {
    const oldScreenSpacePanning = STAGE.orbitcontrols.screenSpacePanning;
    STAGE.orbitcontrols.screenSpacePanning = true;
    STAGE.orbitcontrols.panUp(-0.1, STAGE.orbitcontrols.object.matrix);
    STAGE.orbitcontrols.screenSpacePanning = oldScreenSpacePanning;
  }
}
